import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7826a3e0 = () => interopDefault(import('../pages/affiliates.vue' /* webpackChunkName: "pages/affiliates" */))
const _40f9c96c = () => interopDefault(import('../pages/agency-plans.vue' /* webpackChunkName: "pages/agency-plans" */))
const _18c290ae = () => interopDefault(import('../pages/analysis/index.vue' /* webpackChunkName: "pages/analysis/index" */))
const _19a62ea2 = () => interopDefault(import('../pages/analytics/index.vue' /* webpackChunkName: "pages/analytics/index" */))
const _46231850 = () => interopDefault(import('../pages/api-docs.vue' /* webpackChunkName: "pages/api-docs" */))
const _2d615d16 = () => interopDefault(import('../pages/apply-promo.vue' /* webpackChunkName: "pages/apply-promo" */))
const _796f0de1 = () => interopDefault(import('../pages/automation.vue' /* webpackChunkName: "pages/automation" */))
const _37d97e4c = () => interopDefault(import('../pages/campaigns/index.vue' /* webpackChunkName: "pages/campaigns/index" */))
const _6444adfe = () => interopDefault(import('../pages/charge.vue' /* webpackChunkName: "pages/charge" */))
const _17a6f00d = () => interopDefault(import('../pages/content-library.vue' /* webpackChunkName: "pages/content-library" */))
const _b5acd40e = () => interopDefault(import('../pages/conversations/index.vue' /* webpackChunkName: "pages/conversations/index" */))
const _6581009a = () => interopDefault(import('../pages/dms/index.vue' /* webpackChunkName: "pages/dms/index" */))
const _81381188 = () => interopDefault(import('../pages/drafts.vue' /* webpackChunkName: "pages/drafts" */))
const _158af906 = () => interopDefault(import('../pages/enterprise-contact-us.vue' /* webpackChunkName: "pages/enterprise-contact-us" */))
const _04ecc226 = () => interopDefault(import('../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _01f59e8c = () => interopDefault(import('../pages/history.vue' /* webpackChunkName: "pages/history" */))
const _e329c322 = () => interopDefault(import('../pages/import.vue' /* webpackChunkName: "pages/import" */))
const _6bc9692c = () => interopDefault(import('../pages/integrations/index.vue' /* webpackChunkName: "pages/integrations/index" */))
const _12e0f9bc = () => interopDefault(import('../pages/legal/index.vue' /* webpackChunkName: "pages/legal/index" */))
const _3b6389ab = () => interopDefault(import('../pages/list-of-nsfw-subreddits.vue' /* webpackChunkName: "pages/list-of-nsfw-subreddits" */))
const _cc1156e2 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _1bf77458 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _af25e636 = () => interopDefault(import('../pages/onboarding.vue' /* webpackChunkName: "pages/onboarding" */))
const _7eced710 = () => interopDefault(import('../pages/plans.vue' /* webpackChunkName: "pages/plans" */))
const _20a41b4a = () => interopDefault(import('../pages/rewards.vue' /* webpackChunkName: "pages/rewards" */))
const _ff4daab2 = () => interopDefault(import('../pages/safety-letter.vue' /* webpackChunkName: "pages/safety-letter" */))
const _c30ce03e = () => interopDefault(import('../pages/schedule.vue' /* webpackChunkName: "pages/schedule" */))
const _3390acd3 = () => interopDefault(import('../pages/scheduled.vue' /* webpackChunkName: "pages/scheduled" */))
const _b270d7a0 = () => interopDefault(import('../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _1d65ab3c = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _3d3b104f = () => interopDefault(import('../pages/subreddit-lists/index.vue' /* webpackChunkName: "pages/subreddit-lists/index" */))
const _088b1ca2 = () => interopDefault(import('../pages/subreddits/index.vue' /* webpackChunkName: "pages/subreddits/index" */))
const _c31d86ae = () => interopDefault(import('../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _4714d8de = () => interopDefault(import('../pages/trash.vue' /* webpackChunkName: "pages/trash" */))
const _603b702b = () => interopDefault(import('../pages/wrapped.vue' /* webpackChunkName: "pages/wrapped" */))
const _7acd4b29 = () => interopDefault(import('../pages/analysis/redditors.vue' /* webpackChunkName: "pages/analysis/redditors" */))
const _18efd6a4 = () => interopDefault(import('../pages/analytics/bluesky.vue' /* webpackChunkName: "pages/analytics/bluesky" */))
const _70a351f9 = () => interopDefault(import('../pages/analytics/facebook.vue' /* webpackChunkName: "pages/analytics/facebook" */))
const _2f99ad0f = () => interopDefault(import('../pages/analytics/instagram.vue' /* webpackChunkName: "pages/analytics/instagram" */))
const _26616c31 = () => interopDefault(import('../pages/analytics/linkedin.vue' /* webpackChunkName: "pages/analytics/linkedin" */))
const _c86526c8 = () => interopDefault(import('../pages/analytics/mastodon.vue' /* webpackChunkName: "pages/analytics/mastodon" */))
const _4532ae12 = () => interopDefault(import('../pages/analytics/pinterest.vue' /* webpackChunkName: "pages/analytics/pinterest" */))
const _f04fe75e = () => interopDefault(import('../pages/analytics/reddit.vue' /* webpackChunkName: "pages/analytics/reddit" */))
const _3e9ab2c6 = () => interopDefault(import('../pages/analytics/threads.vue' /* webpackChunkName: "pages/analytics/threads" */))
const _1e724e26 = () => interopDefault(import('../pages/analytics/tiktok.vue' /* webpackChunkName: "pages/analytics/tiktok" */))
const _125b5262 = () => interopDefault(import('../pages/analytics/tumblr.vue' /* webpackChunkName: "pages/analytics/tumblr" */))
const _5d6f3490 = () => interopDefault(import('../pages/analytics/twitter.vue' /* webpackChunkName: "pages/analytics/twitter" */))
const _743e4580 = () => interopDefault(import('../pages/analytics/youtube.vue' /* webpackChunkName: "pages/analytics/youtube" */))
const _45a51cf7 = () => interopDefault(import('../pages/bluesky/import.vue' /* webpackChunkName: "pages/bluesky/import" */))
const _29ead41c = () => interopDefault(import('../pages/campaigns/create.vue' /* webpackChunkName: "pages/campaigns/create" */))
const _70a3f672 = () => interopDefault(import('../pages/catch/imgur.vue' /* webpackChunkName: "pages/catch/imgur" */))
const _0264c16b = () => interopDefault(import('../pages/dms/create.vue' /* webpackChunkName: "pages/dms/create" */))
const _74837f67 = () => interopDefault(import('../pages/dms/inbox.vue' /* webpackChunkName: "pages/dms/inbox" */))
const _e8c16328 = () => interopDefault(import('../pages/instagram/import.vue' /* webpackChunkName: "pages/instagram/import" */))
const _4d903650 = () => interopDefault(import('../pages/legal/privacy.vue' /* webpackChunkName: "pages/legal/privacy" */))
const _27a95fcb = () => interopDefault(import('../pages/legal/refunds.vue' /* webpackChunkName: "pages/legal/refunds" */))
const _bee57d52 = () => interopDefault(import('../pages/legal/terms.vue' /* webpackChunkName: "pages/legal/terms" */))
const _ab00f920 = () => interopDefault(import('../pages/posts/inbox.vue' /* webpackChunkName: "pages/posts/inbox" */))
const _17a0811c = () => interopDefault(import('../pages/reddit/import.vue' /* webpackChunkName: "pages/reddit/import" */))
const _a03e0964 = () => interopDefault(import('../pages/reddit/schedule.vue' /* webpackChunkName: "pages/reddit/schedule" */))
const _0c8e0dd1 = () => interopDefault(import('../pages/settings/change-email.vue' /* webpackChunkName: "pages/settings/change-email" */))
const _3601a8f6 = () => interopDefault(import('../pages/settings/change-password.vue' /* webpackChunkName: "pages/settings/change-password" */))
const _2d133ff8 = () => interopDefault(import('../pages/settings/checklist.vue' /* webpackChunkName: "pages/settings/checklist" */))
const _0e75e634 = () => interopDefault(import('../pages/settings/clients.vue' /* webpackChunkName: "pages/settings/clients" */))
const _4677a31c = () => interopDefault(import('../pages/settings/custom-schedules.vue' /* webpackChunkName: "pages/settings/custom-schedules" */))
const _6aa56c18 = () => interopDefault(import('../pages/settings/danger-zone.vue' /* webpackChunkName: "pages/settings/danger-zone" */))
const _14ba9346 = () => interopDefault(import('../pages/settings/export.vue' /* webpackChunkName: "pages/settings/export" */))
const _59c1e5b2 = () => interopDefault(import('../pages/settings/manage-users.vue' /* webpackChunkName: "pages/settings/manage-users" */))
const _7ba04174 = () => interopDefault(import('../pages/settings/notifications.vue' /* webpackChunkName: "pages/settings/notifications" */))
const _4f53dc6a = () => interopDefault(import('../pages/settings/proxies.vue' /* webpackChunkName: "pages/settings/proxies" */))
const _4c234ea2 = () => interopDefault(import('../pages/settings/subscription.vue' /* webpackChunkName: "pages/settings/subscription" */))
const _4bee0300 = () => interopDefault(import('../pages/subreddits/discovery.vue' /* webpackChunkName: "pages/subreddits/discovery" */))
const _47cf81aa = () => interopDefault(import('../pages/subreddits/recommendations.vue' /* webpackChunkName: "pages/subreddits/recommendations" */))
const _c99a92d6 = () => interopDefault(import('../pages/threads/import.vue' /* webpackChunkName: "pages/threads/import" */))
const _23eb8d00 = () => interopDefault(import('../pages/tiktok/import.vue' /* webpackChunkName: "pages/tiktok/import" */))
const _3fa5567c = () => interopDefault(import('../pages/tools/ai-social-media-generators.vue' /* webpackChunkName: "pages/tools/ai-social-media-generators" */))
const _4a1d072c = () => interopDefault(import('../pages/tools/bluesky-post-generator.vue' /* webpackChunkName: "pages/tools/bluesky-post-generator" */))
const _19dfba82 = () => interopDefault(import('../pages/tools/facebook-post-generator.vue' /* webpackChunkName: "pages/tools/facebook-post-generator" */))
const _1c887643 = () => interopDefault(import('../pages/tools/instagram-caption-generator.vue' /* webpackChunkName: "pages/tools/instagram-caption-generator" */))
const _72035187 = () => interopDefault(import('../pages/tools/linkedin-post-generator.vue' /* webpackChunkName: "pages/tools/linkedin-post-generator" */))
const _3f0f0dbc = () => interopDefault(import('../pages/tools/mastodon-post-generator.vue' /* webpackChunkName: "pages/tools/mastodon-post-generator" */))
const _3f5e65cc = () => interopDefault(import('../pages/tools/pinterest-pin-generator.vue' /* webpackChunkName: "pages/tools/pinterest-pin-generator" */))
const _17e60a1c = () => interopDefault(import('../pages/tools/reddit-post-title-generator.vue' /* webpackChunkName: "pages/tools/reddit-post-title-generator" */))
const _87dacff0 = () => interopDefault(import('../pages/tools/threads-post-generator.vue' /* webpackChunkName: "pages/tools/threads-post-generator" */))
const _52338c17 = () => interopDefault(import('../pages/tools/tiktok-caption-generator.vue' /* webpackChunkName: "pages/tools/tiktok-caption-generator" */))
const _65b1308c = () => interopDefault(import('../pages/tools/x-twitter-tweet-generator.vue' /* webpackChunkName: "pages/tools/x-twitter-tweet-generator" */))
const _770ccaa0 = () => interopDefault(import('../pages/tools/youtube-shorts-title-generator.vue' /* webpackChunkName: "pages/tools/youtube-shorts-title-generator" */))
const _55287d8b = () => interopDefault(import('../pages/twitter/import.vue' /* webpackChunkName: "pages/twitter/import" */))
const _7ac5d370 = () => interopDefault(import('../pages/settings/accounts/bluesky.vue' /* webpackChunkName: "pages/settings/accounts/bluesky" */))
const _498ceead = () => interopDefault(import('../pages/settings/accounts/facebook.vue' /* webpackChunkName: "pages/settings/accounts/facebook" */))
const _a503ab6e = () => interopDefault(import('../pages/settings/accounts/imgur.vue' /* webpackChunkName: "pages/settings/accounts/imgur" */))
const _73e3a6db = () => interopDefault(import('../pages/settings/accounts/instagram.vue' /* webpackChunkName: "pages/settings/accounts/instagram" */))
const _0169ee36 = () => interopDefault(import('../pages/settings/accounts/linkedin.vue' /* webpackChunkName: "pages/settings/accounts/linkedin" */))
const _74b70950 = () => interopDefault(import('../pages/settings/accounts/mastodon.vue' /* webpackChunkName: "pages/settings/accounts/mastodon" */))
const _21b0a2c3 = () => interopDefault(import('../pages/settings/accounts/pinterest.vue' /* webpackChunkName: "pages/settings/accounts/pinterest" */))
const _30294605 = () => interopDefault(import('../pages/settings/accounts/reddit.vue' /* webpackChunkName: "pages/settings/accounts/reddit" */))
const _0f2a6cae = () => interopDefault(import('../pages/settings/accounts/redgifs.vue' /* webpackChunkName: "pages/settings/accounts/redgifs" */))
const _04e3538a = () => interopDefault(import('../pages/settings/accounts/secure-connect.vue' /* webpackChunkName: "pages/settings/accounts/secure-connect" */))
const _bf1ea0dc = () => interopDefault(import('../pages/settings/accounts/threads.vue' /* webpackChunkName: "pages/settings/accounts/threads" */))
const _cdcfdabe = () => interopDefault(import('../pages/settings/accounts/tiktok.vue' /* webpackChunkName: "pages/settings/accounts/tiktok" */))
const _c1b8defa = () => interopDefault(import('../pages/settings/accounts/tumblr.vue' /* webpackChunkName: "pages/settings/accounts/tumblr" */))
const _81759d48 = () => interopDefault(import('../pages/settings/accounts/twitter.vue' /* webpackChunkName: "pages/settings/accounts/twitter" */))
const _27b6da0c = () => interopDefault(import('../pages/settings/accounts/youtube.vue' /* webpackChunkName: "pages/settings/accounts/youtube" */))
const _4a24e286 = () => interopDefault(import('../pages/settings/post-settings/bluesky.vue' /* webpackChunkName: "pages/settings/post-settings/bluesky" */))
const _587e07a2 = () => interopDefault(import('../pages/settings/post-settings/reddit.vue' /* webpackChunkName: "pages/settings/post-settings/reddit" */))
const _6fcfbea8 = () => interopDefault(import('../pages/settings/post-settings/threads.vue' /* webpackChunkName: "pages/settings/post-settings/threads" */))
const _3cafc8cb = () => interopDefault(import('../pages/settings/post-settings/tiktok.vue' /* webpackChunkName: "pages/settings/post-settings/tiktok" */))
const _e2b77f1c = () => interopDefault(import('../pages/settings/post-settings/twitter.vue' /* webpackChunkName: "pages/settings/post-settings/twitter" */))
const _54325984 = () => interopDefault(import('../pages/confirm-email/_token.vue' /* webpackChunkName: "pages/confirm-email/_token" */))
const _4ccb7d68 = () => interopDefault(import('../pages/connect/_token/index.vue' /* webpackChunkName: "pages/connect/_token/index" */))
const _39f394d6 = () => interopDefault(import('../pages/r/_code.vue' /* webpackChunkName: "pages/r/_code" */))
const _1ee37c16 = () => interopDefault(import('../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _b97ec44c = () => interopDefault(import('../pages/subreddit-lists/_category.vue' /* webpackChunkName: "pages/subreddit-lists/_category" */))
const _6752eeac = () => interopDefault(import('../pages/subreddits/_subredditName.vue' /* webpackChunkName: "pages/subreddits/_subredditName" */))
const _51c5b8b6 = () => interopDefault(import('../pages/subscribe/_planCode.vue' /* webpackChunkName: "pages/subscribe/_planCode" */))
const _dbc0811e = () => interopDefault(import('../pages/connect/_token/invalid.vue' /* webpackChunkName: "pages/connect/_token/invalid" */))
const _7f57277d = () => interopDefault(import('../pages/connect/_token/success.vue' /* webpackChunkName: "pages/connect/_token/success" */))
const _d3ec39e6 = () => interopDefault(import('../pages/join/_token/invalid.vue' /* webpackChunkName: "pages/join/_token/invalid" */))
const _5f609d10 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/affiliates",
    component: _7826a3e0,
    name: "affiliates"
  }, {
    path: "/agency-plans",
    component: _40f9c96c,
    name: "agency-plans"
  }, {
    path: "/analysis",
    component: _18c290ae,
    name: "analysis"
  }, {
    path: "/analytics",
    component: _19a62ea2,
    name: "analytics"
  }, {
    path: "/api-docs",
    component: _46231850,
    name: "api-docs"
  }, {
    path: "/apply-promo",
    component: _2d615d16,
    name: "apply-promo"
  }, {
    path: "/automation",
    component: _796f0de1,
    name: "automation"
  }, {
    path: "/campaigns",
    component: _37d97e4c,
    name: "campaigns"
  }, {
    path: "/charge",
    component: _6444adfe,
    name: "charge"
  }, {
    path: "/content-library",
    component: _17a6f00d,
    name: "content-library"
  }, {
    path: "/conversations",
    component: _b5acd40e,
    name: "conversations"
  }, {
    path: "/dms",
    component: _6581009a,
    name: "dms"
  }, {
    path: "/drafts",
    component: _81381188,
    name: "drafts"
  }, {
    path: "/enterprise-contact-us",
    component: _158af906,
    name: "enterprise-contact-us"
  }, {
    path: "/forgot",
    component: _04ecc226,
    name: "forgot"
  }, {
    path: "/history",
    component: _01f59e8c,
    name: "history"
  }, {
    path: "/import",
    component: _e329c322,
    name: "import"
  }, {
    path: "/integrations",
    component: _6bc9692c,
    name: "integrations"
  }, {
    path: "/legal",
    component: _12e0f9bc,
    name: "legal"
  }, {
    path: "/list-of-nsfw-subreddits",
    component: _3b6389ab,
    name: "list-of-nsfw-subreddits"
  }, {
    path: "/login",
    component: _cc1156e2,
    name: "login"
  }, {
    path: "/logout",
    component: _1bf77458,
    name: "logout"
  }, {
    path: "/onboarding",
    component: _af25e636,
    name: "onboarding"
  }, {
    path: "/plans",
    component: _7eced710,
    name: "plans"
  }, {
    path: "/rewards",
    component: _20a41b4a,
    name: "rewards"
  }, {
    path: "/safety-letter",
    component: _ff4daab2,
    name: "safety-letter"
  }, {
    path: "/schedule",
    component: _c30ce03e,
    name: "schedule"
  }, {
    path: "/scheduled",
    component: _3390acd3,
    name: "scheduled"
  }, {
    path: "/settings",
    component: _b270d7a0,
    name: "settings"
  }, {
    path: "/signup",
    component: _1d65ab3c,
    name: "signup"
  }, {
    path: "/subreddit-lists",
    component: _3d3b104f,
    name: "subreddit-lists"
  }, {
    path: "/subreddits",
    component: _088b1ca2,
    name: "subreddits"
  }, {
    path: "/success",
    component: _c31d86ae,
    name: "success"
  }, {
    path: "/trash",
    component: _4714d8de,
    name: "trash"
  }, {
    path: "/wrapped",
    component: _603b702b,
    name: "wrapped"
  }, {
    path: "/analysis/redditors",
    component: _7acd4b29,
    name: "analysis:redditors"
  }, {
    path: "/analytics/bluesky",
    component: _18efd6a4,
    name: "analytics:bluesky"
  }, {
    path: "/analytics/facebook",
    component: _70a351f9,
    name: "analytics:facebook"
  }, {
    path: "/analytics/instagram",
    component: _2f99ad0f,
    name: "analytics:instagram"
  }, {
    path: "/analytics/linkedin",
    component: _26616c31,
    name: "analytics:linkedin"
  }, {
    path: "/analytics/mastodon",
    component: _c86526c8,
    name: "analytics:mastodon"
  }, {
    path: "/analytics/pinterest",
    component: _4532ae12,
    name: "analytics:pinterest"
  }, {
    path: "/analytics/reddit",
    component: _f04fe75e,
    name: "analytics:reddit"
  }, {
    path: "/analytics/threads",
    component: _3e9ab2c6,
    name: "analytics:threads"
  }, {
    path: "/analytics/tiktok",
    component: _1e724e26,
    name: "analytics:tiktok"
  }, {
    path: "/analytics/tumblr",
    component: _125b5262,
    name: "analytics:tumblr"
  }, {
    path: "/analytics/twitter",
    component: _5d6f3490,
    name: "analytics:twitter"
  }, {
    path: "/analytics/youtube",
    component: _743e4580,
    name: "analytics:youtube"
  }, {
    path: "/bluesky/import",
    component: _45a51cf7,
    name: "bluesky:import"
  }, {
    path: "/campaigns/create",
    component: _29ead41c,
    name: "campaigns:create"
  }, {
    path: "/catch/imgur",
    component: _70a3f672,
    name: "catch:imgur"
  }, {
    path: "/dms/create",
    component: _0264c16b,
    name: "dms:create"
  }, {
    path: "/dms/inbox",
    component: _74837f67,
    name: "dms:inbox"
  }, {
    path: "/instagram/import",
    component: _e8c16328,
    name: "instagram:import"
  }, {
    path: "/legal/privacy",
    component: _4d903650,
    name: "legal:privacy"
  }, {
    path: "/legal/refunds",
    component: _27a95fcb,
    name: "legal:refunds"
  }, {
    path: "/legal/terms",
    component: _bee57d52,
    name: "legal:terms"
  }, {
    path: "/posts/inbox",
    component: _ab00f920,
    name: "posts:inbox"
  }, {
    path: "/reddit/import",
    component: _17a0811c,
    name: "reddit:import"
  }, {
    path: "/reddit/schedule",
    component: _a03e0964,
    name: "reddit:schedule"
  }, {
    path: "/settings/change-email",
    component: _0c8e0dd1,
    name: "settings:change-email"
  }, {
    path: "/settings/change-password",
    component: _3601a8f6,
    name: "settings:change-password"
  }, {
    path: "/settings/checklist",
    component: _2d133ff8,
    name: "settings:checklist"
  }, {
    path: "/settings/clients",
    component: _0e75e634,
    name: "settings:clients"
  }, {
    path: "/settings/custom-schedules",
    component: _4677a31c,
    name: "settings:custom-schedules"
  }, {
    path: "/settings/danger-zone",
    component: _6aa56c18,
    name: "settings:danger-zone"
  }, {
    path: "/settings/export",
    component: _14ba9346,
    name: "settings:export"
  }, {
    path: "/settings/manage-users",
    component: _59c1e5b2,
    name: "settings:manage-users"
  }, {
    path: "/settings/notifications",
    component: _7ba04174,
    name: "settings:notifications"
  }, {
    path: "/settings/proxies",
    component: _4f53dc6a,
    name: "settings:proxies"
  }, {
    path: "/settings/subscription",
    component: _4c234ea2,
    name: "settings:subscription"
  }, {
    path: "/subreddits/discovery",
    component: _4bee0300,
    name: "subreddits:discovery"
  }, {
    path: "/subreddits/recommendations",
    component: _47cf81aa,
    name: "subreddits:recommendations"
  }, {
    path: "/threads/import",
    component: _c99a92d6,
    name: "threads:import"
  }, {
    path: "/tiktok/import",
    component: _23eb8d00,
    name: "tiktok:import"
  }, {
    path: "/tools/ai-social-media-generators",
    component: _3fa5567c,
    name: "tools:ai-social-media-generators"
  }, {
    path: "/tools/bluesky-post-generator",
    component: _4a1d072c,
    name: "tools:bluesky-post-generator"
  }, {
    path: "/tools/facebook-post-generator",
    component: _19dfba82,
    name: "tools:facebook-post-generator"
  }, {
    path: "/tools/instagram-caption-generator",
    component: _1c887643,
    name: "tools:instagram-caption-generator"
  }, {
    path: "/tools/linkedin-post-generator",
    component: _72035187,
    name: "tools:linkedin-post-generator"
  }, {
    path: "/tools/mastodon-post-generator",
    component: _3f0f0dbc,
    name: "tools:mastodon-post-generator"
  }, {
    path: "/tools/pinterest-pin-generator",
    component: _3f5e65cc,
    name: "tools:pinterest-pin-generator"
  }, {
    path: "/tools/reddit-post-title-generator",
    component: _17e60a1c,
    name: "tools:reddit-post-title-generator"
  }, {
    path: "/tools/threads-post-generator",
    component: _87dacff0,
    name: "tools:threads-post-generator"
  }, {
    path: "/tools/tiktok-caption-generator",
    component: _52338c17,
    name: "tools:tiktok-caption-generator"
  }, {
    path: "/tools/x-twitter-tweet-generator",
    component: _65b1308c,
    name: "tools:x-twitter-tweet-generator"
  }, {
    path: "/tools/youtube-shorts-title-generator",
    component: _770ccaa0,
    name: "tools:youtube-shorts-title-generator"
  }, {
    path: "/twitter/import",
    component: _55287d8b,
    name: "twitter:import"
  }, {
    path: "/settings/accounts/bluesky",
    component: _7ac5d370,
    name: "settings:accounts:bluesky"
  }, {
    path: "/settings/accounts/facebook",
    component: _498ceead,
    name: "settings:accounts:facebook"
  }, {
    path: "/settings/accounts/imgur",
    component: _a503ab6e,
    name: "settings:accounts:imgur"
  }, {
    path: "/settings/accounts/instagram",
    component: _73e3a6db,
    name: "settings:accounts:instagram"
  }, {
    path: "/settings/accounts/linkedin",
    component: _0169ee36,
    name: "settings:accounts:linkedin"
  }, {
    path: "/settings/accounts/mastodon",
    component: _74b70950,
    name: "settings:accounts:mastodon"
  }, {
    path: "/settings/accounts/pinterest",
    component: _21b0a2c3,
    name: "settings:accounts:pinterest"
  }, {
    path: "/settings/accounts/reddit",
    component: _30294605,
    name: "settings:accounts:reddit"
  }, {
    path: "/settings/accounts/redgifs",
    component: _0f2a6cae,
    name: "settings:accounts:redgifs"
  }, {
    path: "/settings/accounts/secure-connect",
    component: _04e3538a,
    name: "settings:accounts:secure-connect"
  }, {
    path: "/settings/accounts/threads",
    component: _bf1ea0dc,
    name: "settings:accounts:threads"
  }, {
    path: "/settings/accounts/tiktok",
    component: _cdcfdabe,
    name: "settings:accounts:tiktok"
  }, {
    path: "/settings/accounts/tumblr",
    component: _c1b8defa,
    name: "settings:accounts:tumblr"
  }, {
    path: "/settings/accounts/twitter",
    component: _81759d48,
    name: "settings:accounts:twitter"
  }, {
    path: "/settings/accounts/youtube",
    component: _27b6da0c,
    name: "settings:accounts:youtube"
  }, {
    path: "/settings/post-settings/bluesky",
    component: _4a24e286,
    name: "settings:post-settings:bluesky"
  }, {
    path: "/settings/post-settings/reddit",
    component: _587e07a2,
    name: "settings:post-settings:reddit"
  }, {
    path: "/settings/post-settings/threads",
    component: _6fcfbea8,
    name: "settings:post-settings:threads"
  }, {
    path: "/settings/post-settings/tiktok",
    component: _3cafc8cb,
    name: "settings:post-settings:tiktok"
  }, {
    path: "/settings/post-settings/twitter",
    component: _e2b77f1c,
    name: "settings:post-settings:twitter"
  }, {
    path: "/confirm-email/:token?",
    component: _54325984,
    name: "confirm-email:token"
  }, {
    path: "/connect/:token",
    component: _4ccb7d68,
    name: "connect:token"
  }, {
    path: "/r/:code?",
    component: _39f394d6,
    name: "r:code"
  }, {
    path: "/reset-password/:token?",
    component: _1ee37c16,
    name: "reset-password:token"
  }, {
    path: "/subreddit-lists/:category",
    component: _b97ec44c,
    name: "subreddit-lists:category"
  }, {
    path: "/subreddits/:subredditName",
    component: _6752eeac,
    name: "subreddits:subredditName"
  }, {
    path: "/subscribe/:planCode?",
    component: _51c5b8b6,
    name: "subscribe:planCode"
  }, {
    path: "/connect/:token?/invalid",
    component: _dbc0811e,
    name: "connect:token:invalid"
  }, {
    path: "/connect/:token?/success",
    component: _7f57277d,
    name: "connect:token:success"
  }, {
    path: "/join/:token?/invalid",
    component: _d3ec39e6,
    name: "join:token:invalid"
  }, {
    path: "/",
    component: _5f609d10,
    name: "index"
  }, {
    path: "/posts/edit/:postId",
    component: _a03e0964,
    props: true,
    name: "posts:edit"
  }, {
    path: "/reddit/schedule/:postId",
    component: _a03e0964,
    props: true,
    name: "reddit:edit"
  }, {
    path: "/twitter/schedule/",
    component: _c30ce03e,
    props: {"platform":"twitter"},
    name: "twitter:schedule"
  }, {
    path: "/threads/schedule/",
    component: _c30ce03e,
    props: {"platform":"threads"},
    name: "threads:schedule"
  }, {
    path: "/instagram/schedule/",
    component: _c30ce03e,
    props: {"platform":"instagram"},
    name: "instagram:schedule"
  }, {
    path: "/facebook/schedule/",
    component: _c30ce03e,
    props: {"platform":"facebook"},
    name: "facebook:schedule"
  }, {
    path: "/tiktok/schedule/",
    component: _c30ce03e,
    props: {"platform":"tiktok"},
    name: "tiktok:schedule"
  }, {
    path: "/linkedin/schedule/",
    component: _c30ce03e,
    props: {"platform":"linkedin"},
    name: "linkedin:schedule"
  }, {
    path: "/youtube/schedule/",
    component: _c30ce03e,
    props: {"platform":"youtube"},
    name: "youtube:schedule"
  }, {
    path: "/pinterest/schedule/",
    component: _c30ce03e,
    props: {"platform":"pinterest"},
    name: "pinterest:schedule"
  }, {
    path: "/bluesky/schedule/",
    component: _c30ce03e,
    props: {"platform":"bluesky"},
    name: "bluesky:schedule"
  }, {
    path: "/tumblr/schedule/",
    component: _c30ce03e,
    props: {"platform":"tumblr"},
    name: "tumblr:schedule"
  }, {
    path: "/mastodon/schedule/",
    component: _c30ce03e,
    props: {"platform":"mastodon"},
    name: "mastodon:schedule"
  }, {
    path: "/dms/edit/:dmId",
    component: _0264c16b,
    props: true,
    name: "dms:edit"
  }, {
    path: "/campaigns/edit/:campaignId",
    component: _29ead41c,
    props: true,
    name: "campaigns:edit"
  }, {
    path: "/analysis/subreddit/:subredditName",
    component: _18c290ae,
    props: true,
    name: "analysis:name"
  }, {
    path: "/analysis/redditors/:username",
    component: _7acd4b29,
    props: true,
    name: "redditors:name"
  }, {
    path: "/signin",
    component: _cc1156e2,
    meta: {"redirect":true}
  }, {
    path: "/terms",
    component: _bee57d52,
    meta: {"redirect":true}
  }, {
    path: "/privacy",
    component: _4d903650,
    meta: {"redirect":true}
  }, {
    path: "/refunds",
    component: _27a95fcb,
    meta: {"redirect":true}
  }, {
    path: "/settings",
    component: _b270d7a0,
    meta: {"redirect":true}
  }, {
    path: "/profile",
    component: _b270d7a0,
    meta: {"redirect":true}
  }, {
    path: "/profile/accounts",
    component: _30294605,
    meta: {"redirect":true}
  }, {
    path: "/profile/notifications",
    component: _7ba04174,
    meta: {"redirect":true}
  }, {
    path: "/profile/change-email",
    component: _0c8e0dd1,
    meta: {"redirect":true}
  }, {
    path: "/profile/change-password",
    component: _3601a8f6,
    meta: {"redirect":true}
  }, {
    path: "/profile/checklist",
    component: _2d133ff8,
    meta: {"redirect":true}
  }, {
    path: "/profile/post-settings",
    component: _587e07a2,
    meta: {"redirect":true}
  }, {
    path: "/profile/subscription",
    component: _4c234ea2,
    meta: {"redirect":true}
  }, {
    path: "/posts/create",
    component: _a03e0964,
    meta: {"redirect":true}
  }, {
    path: "/settings/accounts",
    component: _30294605,
    meta: {"redirect":true}
  }, {
    path: "/settings/post-settings",
    component: _587e07a2,
    meta: {"redirect":true}
  }, {
    path: "/help",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href = 'https://help.postpone.app/';
        }
  }, {
    path: "/api-docs",
    meta: {"redirect":true},
    beforeEnter: function(to, from, next) {
          window.location.href =
          'https://help.postpone.app/api-docs/postpone-api';
        }
  }, {
    path: "/dashboard",
    redirect: "/scheduled"
  }, {
    path: "/submissions/twitter",
    redirect: "/history"
  }, {
    path: "/submissions/threads",
    redirect: "/history"
  }, {
    path: "/submissions/instagram",
    redirect: "/history"
  }, {
    path: "/submissions/facebook",
    redirect: "/history"
  }, {
    path: "/submissions/tiktok",
    redirect: "/history"
  }, {
    path: "/submissions/linkedin",
    redirect: "/history"
  }, {
    path: "/submissions/youtube",
    redirect: "/history"
  }, {
    path: "/submissions/pinterest",
    redirect: "/history"
  }, {
    path: "/submissions/bluesky",
    redirect: "/history"
  }, {
    path: "/submissions/tumblr",
    redirect: "/history"
  }, {
    path: "/submissions/mastodon",
    redirect: "/history"
  }, {
    path: "/submissions/reddit",
    redirect: "/history"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
